// ------------------------------------
// Category
// ------------------------------------
export const CATEGORY_STORE = 'CATEGORY_STORE'
export const CATEGORY_TOGGLE = 'CATEGORY_TOGGLE'
export const CATEGORY_ACTIVE = 'CATEGORY_ACTIVE'
export const CATEGORY_OPEN = 'CATEGORY_OPEN'
export const NEWS = 'NEWS'
export const LOADING_CATEGORY = 'LOADING_CATEGORY'

// ------------------------------------
// Common
// ------------------------------------
export const COMMON_STORE = 'COMMON_STORE'
export const COMMON_CHANGE_SHIPPING = 'COMMON_CHANGE_SHIPPING'
export const COMMON_CHANGE_PAYMENT = 'COMMON_CHANGE_PAYMENT'
export const COMMON_SET_SHIPPING_PRICE = 'COMMON_SET_SHIPPING_PRICE'
export const COMMON_OPEN_MODAL = 'COMMON_OPEN_MODAL'
export const COMMON_CLOSE_MODAL = 'COMMON_CLOSE_MODAL'
export const HEADER_CART = 'HEADER_CART'
export const FILTER_TOGGLE = 'FILTER_TOGGLE'
export const LOADING = 'LOADING'
export const SEARCH_LOADING = 'SEARCH_LOADING'
export const LOGIN_TOGGLE = 'LOGIN_TOGGLE'
export const LOST_PASS_TOGGLE = 'LOST_PASS_TOGGLE'
export const LOGIN_USER = 'LOGIN_USER'
export const LOGOUT_USER = 'LOGOUT_USER'
export const INPUT_MESSAGE = 'INPUT_MESSAGE'
export const INPUT_STATUS = 'INPUT_STATUS'
export const PROFILE_CHANGED = 'PROFILE_CHANGED'
export const SET_USER_PROFILE = 'SET_USER_PROFILE'
export const SET_ALERT_NOTIFICATION = 'SET_ALERT_NOTIFICATION'
export const HANDLE_LOBBED_PRODUCT = 'HANDLE_LOBBED_PRODUCT'
export const ADD_OFFSET = 'ADD_OFFSET'
export const COUNTRIES_STORE = 'COUNTRIES_STORE'
export const LOGIN_OZ = 'LOGIN_OZ'
export const LOGIN_ADMIN = 'LOGIN_ADMIN'
export const STORE_TOKEN = 'STORE_TOKEN'
export const MEC_STORE = 'MEC_STORE'
export const LOADING_LOGIN = 'LOADING_LOGIN'
export const LOADING_COMMON = 'LOADING_COMMON'
export const TOGGLE_LOGIN_MODAL = 'TOGGLE_LOGIN_MODAL'
export const STORE_FAILURED_API_CALLS = 'STORE_FAILURED_API_CALLS'
export const HEADER_MOBILE_SEARCH_BAR = 'HEADER_MOBILE_SEARCH_BAR'
export const TOGGLE_SIDEBAR_CATEGORY = 'TOGGLE_SIDEBAR_CATEGORY'
export const SET_LOADING_PROGRESS = 'SET_LOADING_PROGRESS'
export const LOADING_SALESMEN = 'LOADING_SALESMEN'
export const STORE_SALESMEN = 'STORE_SALESMEN'
export const RESET_STATE = 'RESET_STATE'
export const TOGGLE_ORDER_TYPE_DROPDOWN = 'TOGGLE_ORDER_TYPE_DROPDOWN'
export const OPEN_ORDERS_LOADING = 'OPEN_ORDERS_LOADING'
export const OPEN_ORDERS_STORE = 'OPEN_ORDERS_STORE'
export const TOGGLE_ERROR_MODAL = 'TOGGLE_ERROR_MODAL'
export const STORE_ERROR = 'STORE_ERROR'
export const SET_OPENED_ORDER = 'SET_OPENED_ORDER'
export const DISABLE_OPENED_ORDER = 'DISABLE_OPENED_ORDER'
export const LOADING_SALES = 'LOADING_SALES'
export const STORE_SALES = 'STORE_SALES'
export const SHOWING_HOT_PRODUCTS = 'SHOWING_HOT_PRODUCTS'
export const USE_CREDIT = 'USE_CREDIT'
// ----------------------------T--------
// Orders
// ------------------------------------
export const SET_USER_REGISTRATION = 'SET_USER_REGISTRATION'

// ------------------------------------
// Orders
// ------------------------------------
export const LOADING_ORDERS = 'LOADING_ORDERS'
export const ORDERS_STORE = 'ORDERS_STORE'
export const ORDER_STORE = 'ORDER_STORE'
export const SEARCH_TERM = 'SEARCH_TERM'
export const FILTERED_ORDERS = 'FILTERED_ORDERS'
export const ORDERS_SORT_BY = 'ORDERS_SORT_BY'
export const ORDERS_SORT_ORDER = 'ORDERS_SORT_ORDER'
export const ORDERS_RANGE_CHANGE = 'ORDERS_RANGE_CHANGE'
export const FILTER_ORDERS_BY_RANGE = 'FILTER_ORDERS_BY_RANGE'
export const RESET_RANGE_FILTER = 'RESET_RANGE_FILTER'
export const SORT_ORDERS = 'SORT_ORDERS'
export const DOWNLOADING_ORDER_PDF = 'DOWNLOADING_ORDER_PDF'

// ------------------------------------
// Products
// ------------------------------------
export const PRODUCT_DETAIL_STORE = 'PRODUCT_DETAIL_STORE'
export const PRODUCT_STORE = 'PRODUCT_STORE'
export const MORE_PRODUCT_STORE = 'MORE_PRODUCT_STORE'
export const PRODUCT_LIST = 'PRODUCT_LIST'
export const CHANGE_PRODUCT_QUANTITY = 'CHANGE_PRODUCT_QUANTITY'
export const FILTER_PRODUCTS = 'FILTER_PRODUCTS'
export const PRODUCTS_SORT_BY = 'SORT_BY'
export const PRODUCTS_SORT_ORDER = 'PRODUCTS_SORT_ORDER'
export const DELETE_ALL_PRODUCTS_QUANTITY = 'DELETE_ALL_PRODUCTS_QUANTITY'
export const SEARCH_BY = 'SEARCH_BY'
export const SEARCHED_PRODUCTS = 'SEARCHED_PRODUCTS'
export const CLEAR_SEARCH = 'CLEAR_SEARCH'
export const SET_LOBBED_QUANTITY = 'SET_LOBBED_QUANTITY'
export const SET_LOBBED_PRICE = 'SET_LOBBED_PRICE'
export const LOADING_PRODUCTS = 'LOADING_PRODUCTS'
export const LOADING_MORE_PRODUCTS = 'LOADING_MORE_PRODUCTS'
export const SEARCHING_PRODUCTS = 'SEARCHING_PRODUCTS'
export const IMPORT_SEARCHED_PRODUCTS = 'IMPORT_SEARCHED_PRODUCTS'
export const MORE_PRODUCT_FETCH = 'MORE_PRODUCT_FETCH'
export const SORTED_FULL_PRODUCT_STORE = 'SORTED_FULL_PRODUCT_STORE'
export const SORTED_PRODUCT_STORE = 'SORTED_PRODUCT_STORE'
export const SORT_PRODUCTS = 'SORT_PRODUCTS'
export const FILTER_CLEAR = 'FILTER_CLEAR'

// ------------------------------------
// Cart
// ------------------------------------
export const CART_STORE = 'CART_STORE'
export const ADD_TO_CART = 'ADD_TO_CART'
export const UPDATE_TO_CART = 'UPDATE_TO_CART'
export const DELETE_CART_PRODUCT = 'DELETE_CART_PRODUCT'
export const DELETE_CART = 'DELETE_CART'
export const SELECT_ALL_CART_PRODUCT = 'SELECT_ALL_CART_PRODUCT'
export const SELECT_CART_PRODUCT = 'SELECT_CART_PRODUCT'
export const DESELECT_ALL_CART_PRODUCT = 'DESELECT_ALL_CART_PRODUCT'
export const DESELECT_CART_PRODUCT = 'DESELECT_CART_PRODUCT'
export const DELETE_SELECTED_CART_PRODUCT = 'DELETE_SELECTED_CART_PRODUCT'
export const CART_SET_NOTE = 'CART_SET_NOTE'
export const FINALIZE_ORDER = 'FINALIZE_ORDER'
export const CART_AVAILABLE_TO_IMPORT = 'CART_AVAILABLE_TO_IMPORT'
export const SET_CART_NOTE = 'SET_CART_NOTE'
export const CART_IS_IMPORTING = 'CART_IS_IMPORTING'
export const TEMPORAL_IMPORTED_DATA = 'TEMPORAL_IMPORTED_DATA'
export const IMPORT_CSV_DATA = 'IMPORT_CSV_DATA'
export const SET_PRODUCT_LIST = 'SET_PRODUCT_LIST'
export const LOADING_CART = 'LOADING_CART'
export const LOADING_IMPORT = 'LOADING_IMPORT'
export const CLEAR_CART_NOTE = 'CLEAR_CART_NOTE'
export const CLEAR_DUAL_CART = 'CLEAR_DUAL_CART'
export const FILL_DUAL_CART = 'FILL_DUAL_CART'
export const SET_DUAL_CART_DATA = 'SET_DUAL_CART_DATA'

// ------------------------------------
// Customer
// ------------------------------------
export const CUSTOMERS_STORE = 'CUSTOMERS_STORE'
export const CUSTOMER_ACTION_BAR = 'CUSTOMER_ACTION_BAR'
export const CUSTOMER_ACTION_TYPE = 'CUSTOMER_ACTION_TYPE'
export const FILTER_CUSTOMERS = 'FILTER_CUSTOMERS'
export const SET_SELECTED_USER = 'SET_SELECTED_USER'
export const CLEAR_CUSOMER_DATA = 'CLEAR_CUSOMER_DATA'
export const LOADING_CUSTOMER = 'LOADING_CUSTOMER'
export const CUSTOMER_CART_STORE = 'CUSTOMER_CART_STORE'
export const CUSTOMER_CART_LOADING = 'CUSTOMER_CART_LOADING'
export const CUSTOMER_CART_CLEAR = 'CUSTOMER_CART_CLEAR'
export const GET_TOP_SELLING_COMMON = 'GET_TOP_SELLING_COMMON'
export const GET_TOP_SELLING_USER = 'GET_TOP_SELLING_USER'
export const TOGGLE_CUSTOMER_DETAIL = 'TOGGLE_CUSTOMER_DETAIL'



// WEBPACK FOOTER //
// ./src/store/actionTypes.js